import { render } from "./pageDesc.vue?vue&type=template&id=50a32f40&scoped=true"
import script from "./pageDesc.vue?vue&type=script&lang=js"
export * from "./pageDesc.vue?vue&type=script&lang=js"

import "./pageDesc.vue?vue&type=style&index=0&id=50a32f40&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a32f40"]])

export default __exports__